module.exports = require("string_decoder");


/*****************
 ** WEBPACK FOOTER
 ** external "string_decoder"
 ** module id = 57
 ** module chunks = 0
 **/